import { atom } from 'jotai';

export const isLoggedUserDrawerMenuOpenAtom = atom<boolean>(false);
